export default __webpack_public_path__ + "static/media/sidebar-camera.b30681f8.svg";